export enum INVOICE_INTERVAL {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  HALF_YEAR = 'HALF_YEAR',
  YEARLY = 'YEARLY',
}
